import { TextField } from "components/RenderInput"
import { Col, Row } from "reactstrap"
import { Field } from "redux-form"

export const renderOptionsField = ({
  fields,
  meta: { error, submitFailed },
  handleFieldFocus,
  hasReplies,
}) => (
  <>
    {fields.map((option, index) => (
      <Row key={index} className="my-2 ">
        <Col xs={fields.length > 2 ? 11 : 12} className="my-1">
          <Field
            name={`${option}.answer`}
            component={TextField}
            placeholder={`Option ${index + 1}`}
            style={{ display: "inline" }}
            onFocus={handleFieldFocus}
          />
        </Col>
        <Col xs={1} className="d-flex justify-content-end mt-2">
          {fields.length > 2 && (
            <i
              className="bx bx-sm bx-x"
              style={{
                paddingLeft: "5px",
                cursor: "pointer",
              }}
              onClick={
                hasReplies
                  ? () => {}
                  : () => {
                      fields.remove(index)
                    }
              }
            />
          )}
        </Col>
      </Row>
    ))}
    {submitFailed && error && <span className={"input-error"}>{error}</span>}
    <Row className="my-1">
      <Col>
        <p
          style={{ cursor: "pointer" }}
          onClick={
            hasReplies ? () => {} : () => fields.push({ id: null, answer: "" })
          }
        >
          + Option
        </p>
      </Col>
    </Row>
  </>
)
